import { isArray, isNaN, isNil, isNumber } from "lodash";
import { isPrimitive } from "./validations";
export function acceptIf(val, validate) {
    if (validate(val))
        return val;
    return null;
}
export function eqOrFalsey(v1, v2) {
    if (!v1 && !v2)
        return true;
    return v1 === v2;
}
export function eqOrN(v1, v2) {
    if (v1 == null && v2 == null)
        return true;
    return v1 === v2;
}
export function ensureNN(val, subject) {
    if (val == null)
        throw new Error(`Expected ${subject ?? "value"} to not be nil`);
    return val;
}
export function ensureTruthy(val, subject) {
    if (!val)
        throw new Error(`Expected ${subject ?? "value"} to be truthy`);
    return val;
}
export function ensureNNT(thunk) {
    const val = thunk();
    if (val == null) {
        const subject = thunk
            .toString()
            .replace(/(^(function\s*)?\(.*\)\s*(=>)?\s*(\{\s*)?(return\s*)?|\s*\}$)/g, "");
        throw new Error(`Expected ${subject} to not be nil`);
    }
    return val;
}
export function ensureArr(val) {
    if (isNil(val))
        return [];
    if (isArray(val))
        return val;
    return [val];
}
export function unwrapFirst(val) {
    if (isNil(val))
        return null;
    if (isArray(val))
        return val[0];
    return val;
}
export function toStr(val) {
    return `${val}`;
}
export function toNum(val) {
    const res = typeof val === "string" ? Number(val) : +val;
    if (isNaN(res)) {
        throw new TypeError(`Invalid number: ${val}`);
    }
    return res;
}
// Helper helper to handle num strings safely
export const safeNum = (val) => {
    if (!val || val == null || val === "")
        return 0;
    const parsed = Number(val);
    return isNaN(parsed) ? 0 : parsed;
};
export function humanizeBool(val) {
    return val ? "Yes" : "No";
}
export function toNumIfVal(val) {
    if (val == null || val === "")
        return null;
    return +val;
}
export function toDateIfVal(val) {
    if (val == null)
        return null;
    if (isNumber(val))
        return new Date(val);
    return val;
}
export function toStrIfVal(val) {
    if (val == null)
        return null;
    return `${val}`;
}
export function toStrIfNum(val) {
    if (isNumber(val))
        return val.toFixed(2);
    return val;
}
export function toUfIfEmpty(val) {
    if (!val?.length)
        return undefined;
    return val;
}
export function toNIfFalsy(val) {
    if (!val)
        return null;
    return val;
}
export const toBigIntIfVal = (val) => val == null ? null : BigInt(val);
export const transformProps = (input, transforms) => {
    // biome-ignore lint/suspicious/noExplicitAny: Using correct type here is not possible because the object is incrementally populated
    const res = { ...input };
    for (const [key, transform] of Object.entries(transforms)) {
        // biome-ignore lint/suspicious/noExplicitAny: Actual type varies by item
        res[key] = transform(input[key]);
    }
    return res;
};
export const mapTransformProps = (input, transforms) => input.map(it => transformProps(it, transforms));
export const pmapTransformProps = (input, transforms) => input.then(arr => arr.map(it => transformProps(it, transforms)));
export const falsyToNull = (it) => it || null;
export const truthyToStr = (it) => it == null ? null : `${it}`;
export const strProps = (input, keys) => Object.fromEntries(Object.entries(input).map(([key, val]) => {
    if (keys.includes(key)) {
        return [key, `${val}`];
    }
    return [key, val];
}));
export const stringifyBigInt = (d) => {
    if (typeof d === "bigint")
        return `${d}::bigint`;
    return d;
};
export const parseBigInt = (d) => {
    if (typeof d === "string" && d.match(/^\d+::bigint$/)) {
        return BigInt(d.slice(0, -8));
    }
    return d;
};
export const undefAsNever = (i) => i;
export const nilToUndefAsNever = (i) => (i ?? undefined);
export const toPrimitive = (val) => {
    if (isPrimitive(val))
        return val;
    if (!val)
        return null;
    return `${val}`;
};
export const stripCurrencyPrefix = (val) => {
    if (!val)
        return val;
    return val.replace(/^(rs|inr|₹)\.\s*/i, "");
};
//# sourceMappingURL=coercions.js.map